import React from 'react';
import { useTranslation } from 'react-i18next';

import { Colors, Typography, createClasses } from '@kp/react-ui';

const classes = createClasses({
  content: {
    padding: '16px 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  contact: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  other: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  item: {
    display: 'flex',
    gap: '8px',
  },
  textWeek: {
    color: Colors.Neutral.textWeak,
  },
});

export const LegalImpressum: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.content}>
      <Typography variant="headlineMedium">
        {t('legals.impressum.title')}
      </Typography>
      <div>
        <Typography component="div" variant="labelMedium">
          Kieback&Peter GmbH & Co. KG
        </Typography>
        <Typography component="div" variant="bodyMedium">
          Tempelhofer Weg 50
        </Typography>
        <Typography component="div" variant="bodyMedium">
          12347 Berlin
        </Typography>
        <Typography component="div" variant="bodyMedium">
          Germany
        </Typography>
      </div>
      <div className={classes.contact}>
        <div className={classes.item}>
          <Typography variant="labelMedium">
            {t('legals.impressum.phone')}:
          </Typography>
          <Typography variant="bodyMedium">+49 30 60095-0</Typography>
        </div>
        <div className={classes.item}>
          <Typography variant="labelMedium">
            {t('legals.impressum.fax')}:
          </Typography>
          <Typography variant="bodyMedium">+49 30 60095-164</Typography>
        </div>
        <div className={classes.item}>
          <Typography variant="labelMedium">
            {t('legals.impressum.email')}:
          </Typography>
          <Typography variant="bodyMedium">info@kieback-peter.de</Typography>
        </div>
        <div className={classes.item}>
          <Typography variant="labelMedium">
            {t('legals.impressum.website')}:
          </Typography>
          <Typography variant="bodyMedium">www.kieback-peter.de</Typography>
        </div>
      </div>
      <div className={classes.other}>
        <div className={classes.item}>
          <Typography variant="labelMedium">
            {t('legals.impressum.registered')}:
          </Typography>
          <Typography variant="bodyMedium" className={classes.textWeek}>
            Charlottenburg District Court HRA 9371
          </Typography>
        </div>
        <div className={classes.item}>
          <Typography variant="labelMedium">
            {t('legals.impressum.complementary')}:
          </Typography>
        </div>
        <Typography variant="bodyMedium" className={classes.textWeek}>
          Kieback&Peter Verwaltungs GmbH, Amtsgericht Charlottenburg HRB 210763
          B
        </Typography>
        <Typography
          variant="bodyMedium"
          component="div"
          className={classes.textWeek}
        >
          Tempelhofer Weg 50 <br />
          12347 Berlin <br />
          Germany
        </Typography>
        <div className={classes.item}>
          <Typography variant="labelMedium">
            {t('legals.impressum.managingDirectors')}:
          </Typography>
          <Typography className={classes.textWeek} variant="bodyMedium">
            Dipl.-Kfm. Christoph Paul Ritzkat, Dipl.-Kfm. Jan Wiechmann
          </Typography>
        </div>
        <div className={classes.item}>
          <Typography variant="labelMedium">
            {t('legals.impressum.vatId')}:
          </Typography>
          <Typography className={classes.textWeek} variant="bodyMedium">
            DE 136651427
          </Typography>
        </div>
      </div>
      <Typography
        variant="bodyMedium"
        component="div"
        className={classes.textWeek}
      >
        {t('legals.impressum.disputeResolution')}
      </Typography>
    </div>
  );
};
